import api from "../../api/sphinxAPI";

/** =========== VISUALIZER =========== **/
export const createNewEmail = async function(creatorId) {
  if (!creatorId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/newEmail`,
      data: { creatorId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const addNewBlock = async function(creatorId, emailId, latestIndex) {
  if (!creatorId || !emailId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/newBlock`,
      data: { creatorId, emailId, latestIndex },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const addNewSubblock = async function(creatorId, blockId, latestIndex) {
  if (!creatorId || !blockId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/newSubblock`,
      data: { creatorId, blockId, latestIndex },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const deleteBlock = async function(blockId) {
  if (!blockId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/deleteBlock`,
      data: { blockId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const updateBlockData = async function(block) {
  if (!block) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/blockData`,
      data: { block },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const updateBlockIndexes = async function(blockIndexesData) {
  if (!blockIndexesData) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/blockIndexes`,
      data: { blockIndexesData },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getEmail = async function(emailId) {
  if (!emailId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/email`,
      params: { emailId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getEmailBlocks = async function(emailId) {
  if (!emailId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/emailBlocks`,
      params: { emailId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getAllEmails = async function() {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/allEmails`,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const updateEmailData = async function(email) {
  if (!email) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/emailData`,
      data: { email },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const deleteEmail = async function(emailId) {
  if (!emailId) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/deleteEmail`,
      data: { emailId },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

const EmailRequests = {
  createNewEmail,
  addNewBlock,
  addNewSubblock,
  deleteBlock,
  updateBlockData,
  updateBlockIndexes,
  getEmail,
  getEmailBlocks,
  getAllEmails,
  updateEmailData,
  deleteEmail,
};

export default EmailRequests;
